import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";
import { ServiceName } from "uis/ServicePlan";

export type TPricePlan = {
  id: string;
  service: string;
  plan: number;
  planStartedAt: string;
  planExpiredAt: string;
  limitMeetingRoomNum?: number;
};

export const getPricePlan = async (service: "MEETING" | "VISITORS"): Promise<ResponseType<TPricePlan>> => {
  try {
    const res = await instance.post(`/workspaces/pricing-plan`, { service: service });
    return { success: true, data: res.data as TPricePlan };
  } catch (error) {
    return { success: false, message: "가격 정보를 가져올 수 없습니다." };
  }
};
